export const MEDICAL_HISTORY_MAX_LENGTH = 50000;

export const MEDICAL_HEARING_OPTIONS = [
  'Peripheral (Medical) Hearing Loss', 'Auditory Processing Difficulties (APD-like features)',
  'Hyperacusis (Sound Sensitivity)', 'Hypersensitivity to Specific Frequencies',
  'Auditory Filtering Difficulties', 'Delayed Auditory Processing', 'Fluctuating Hearing Issues',
  'Other hearing issues', 'No hearing issues',
];
export const MEDICAL_VISION_OPTIONS = [
  'Refractive Errors (Common in All Children)', 'Strabismus (Eye Alignment Problems)',
  'Amblyopia (“Lazy Eye”)', 'Visual Processing Differences (Very Common in ASD)',
  'Visual Sensory Sensitivities', 'Visual Attention & Scanning Differences',
  'Depth Perception & Binocular Vision Issues', 'Ocular Motor Dysfunction', 'Other vision issues',
  'No vision issues',
];
export const MEDICAL_SEVERITY_OPTIONS = ['Level-1', 'Level-2', 'Level-3', 'Unknown'];
export const MEDICAL_DELIVERY_OPTIONS = ['Spontaneous', 'C-Section', 'Induced Vaginal', 'Unknown'];
export const MEDICAL_DIAGNOSIS_OPTIONS = [
  'Adjustment Disorder (F43.2)', 'Anxiety (F41.9)', 'Asperger’s syndrome (F84.5)',
  'Attention-deficit hyperactivity disorder (F90.0, F90.1, F90.2, F90.8, F90.9)',
  'Cerebral Palsy (G80.9)', 'Cerebral Visual Impairment: (H47.61)', 'Coffin-Siris Syndrome (Q87.1)',
  'Congenital Heart Failure: (Q24.9)', 'Depression (F33.0, F33.2)', 'Developmental disorder of speech and language, unspecified (F80.9)',
  'Disruptive mood dysregulation disorder (F34.81)', 'Downs Syndrome (Q90.9)', 'Emotional Disturbance Disorder (F98.9)', 'Epilepsy: (G40.0)',
  'Generalized Anxiety Disorder (F41.1)', 'Global Speech Delay (F80)',
  'Mild Intellectual Developmental Disorder (F70)', 'Mixed Receptive-Expressive Language Disorder (F80.2)',
  'Obsessive Compulsive Disorder (F42)', 'Oppositional Defiance Disorder (F91.3)', 'Oral Aversion (F50.82)',
  'Other childhood disintegrative disorder (F84.3)', 'Other pervasive developmental disorders (F84.8)', 'Pediatric Feeding Disorder (R63.32)',
  'Pervasive developmental disorder, unspecified (F84.9)', 'Post-Traumatic Stress Disorder (F43.12)', 'Prader-Willi Syndrome (Q87.11)', 'Rett’s syndrome (F84.2)', 'Sensory Processing Disorder (F88)',
];
export const MEDICAL_SELECTION_OPTIONS = {
  EARLY_INTERVENTION: ['Applied Behavior Analysis', 'Feeding Therapy', 'Speech Therapy', 'Play Therapy', 'Occupational Therapy', 'Special Education Preschool', 'Physical Therapy', 'Other', 'None'],
  PREGNANCY_ISSUE: ['Vaginal bleeding', 'Rh incompatibility', 'Emotional problems', 'Infections', 'Bed-rest', 'Premature Labor', 'Difficulty in conception', 'Threatened miscarriage', 'Excessive swelling', 'Other virus', 'Excessive nausea/vomiting', 'Drug or Alcohol abuse', 'Other', 'None'],
  REGRESSION: ['Speech language', 'Gross motor', 'Fine motor', 'None'],
} as const;
